import { createActions, createReducer } from 'reduxsauce'

import TotaisService from '../../servicos/DetalhesRemuneracaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaTotaisInicio: [],
    buscaTotaisSucesso: ['totais'],
    buscaTotaisErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: [],
    selecionado: null,
    dataAtualizacaoDados: null,
}

// Ação para busca completa
Creators.buscaTotais = filtro => {
    return dispatch => {
        dispatch(Creators.buscaTotaisInicio())
        let serv = new TotaisService()
        return serv
            .consultarDetalhes(filtro)
            .then(response => dispatch(Creators.buscaTotaisSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaTotaisErro(error)))
    }
}

const buscaTotaisInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaTotaisErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaTotaisSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.totais, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_TOTAIS_INICIO]: buscaTotaisInicio,
    [Types.BUSCA_TOTAIS_ERRO]: buscaTotaisErro,
    [Types.BUSCA_TOTAIS_SUCESSO]: buscaTotaisSucesso,
})
